import {getStorage, ref, deleteObject} from 'firebase/storage';

import type {ImageMedia} from '../types/project';

/**
 * Deletes files from firebase storage
 */
export default function deleteFiles(files: Array<ImageMedia>) {
  return Promise.all(
    files.map(
      file =>
        new Promise((resolve, reject) => {
          const storageRef = ref(getStorage(), file.url);

          deleteObject(storageRef).then(resolve).catch(reject);
        })
    )
  );
}
